import { LSK } from "./config";

/**
 * 即用即删埋点数据
 */
export function saveOneTimeData(type: LSK, data: any) {
    // 确保将对象转换为JSON字符串
    const jsonData = typeof data === 'object' ? JSON.stringify(data) : data;
    localStorage.setItem(type, jsonData);
}

export function loadOneTimeData(type: LSK) {
    const data = localStorage.getItem(type);
    if (data) {
        localStorage.removeItem(type);
        return JSON.parse(data);
    }
    return null;
}